import { useQueryClient } from '@tanstack/react-query';
import { useTranslations } from '@unisporkal/localization';
import { useSiteMap } from '@unisporkal/sites';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import useRfSubscriptionStatusData from '../../../api/subscription/useRfSubscriptionStatusData';
import useAcquisitionConfig from './useAcquisitionConfig';
import bannerConfig from '../bannerConfig';
import queryKeys from '../../../../support/uiStateKeys';
import type { BannerContext, BannerResult } from '../types';

const useBanner = (): BannerResult | null => {
  const t = useTranslations();
  const siteMap = useSiteMap();
  const queryClient = useQueryClient();
  const { asset } = useAsset() as {
    asset: { id: string };
  };
  const {
    acquisitionType,
    downloadAgreements,
    hasRfSubscription,
    batchAgreements,
  } = useAcquisitionConfig(asset?.id);
  const rfSubscriptionStatus = useRfSubscriptionStatusData(asset?.id);
  const mode = queryClient.getQueryData<string>([queryKeys.MODE]);

  if (!acquisitionType) return null;

  const rules = bannerConfig[acquisitionType];
  if (!rules || rules.length === 0) return null;

  const context: BannerContext = {
    acquisitionType,
    downloadAgreements,
    batchAgreements,
    asset,
    hasRfSubscription,
    isRfRedownloadable: rfSubscriptionStatus?.rfRedownloadEligible ?? false,
    siteMap,
    mode,
  };

  for (const rule of rules) {
    const result = rule(context, t);
    if (result) return result;
  }

  return null;
};

export default useBanner;
